export enum TooltipColor {
  none,
  green,
  red,
  orange,
  blue,
  dark,
}
